// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".citaat{display:inline-block;position:relative}.citaat.has-focus{color:red}.citaat-content{color:#00f}.modal{position:absolute;left:100%;background-color:#fff;padding:.5rem;box-shadow:var(--box-shadow);z-index:2}", ""]);
// Exports
module.exports = exports;
